import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProductsControllerFindAll$Params } from '@klubovna/api-client';
import { DeleteProductDto, SetRecipeDto } from '@klubovna/api-client';
import { Store } from '@ngrx/store';
import * as ProductsActions from './products.actions';
import { CreateProductData, UpdateProductData } from './products.actions';
import * as ProductsSelectors from './products.selectors';

@Injectable({
  providedIn: 'root',
})
export class ProductsFacade {
  private store = inject(Store);

  products$ = this.store.select(ProductsSelectors.selectAllProducts);
  loading$ = this.store.select(ProductsSelectors.selectProductsLoading);
  error$ = this.store.select(ProductsSelectors.selectProductsError);
  pagination$ = this.store.select(ProductsSelectors.selectProductsPagination);
  params$ = this.store.select(ProductsSelectors.selectProductsParams);

  products = toSignal(this.products$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });
  pagination = toSignal(this.pagination$);
  params = toSignal(this.params$);

  loadProducts(params?: ProductsControllerFindAll$Params): void {
    this.store.dispatch(ProductsActions.loadProducts({ params }));
  }

  createProduct(productData: CreateProductData, recipe?: SetRecipeDto): void {
    this.store.dispatch(ProductsActions.createProduct({ productData, recipe }));
  }

  updateProduct(id: string, productData: UpdateProductData, recipe?: SetRecipeDto, deleteRecipe?: boolean): void {
    this.store.dispatch(ProductsActions.updateProduct({ id, productData, recipe, deleteRecipe }));
  }

  deleteProduct(id: string, deletionParams?: DeleteProductDto): void {
    this.store.dispatch(ProductsActions.deleteProduct({ id, deletionParams }));
  }
}
